<div id="leaflet-contact-broker-agent">
    <div class="dialog-container">
        <div class="dialog-header">
            <span>CONTACT NETWORK AGENT</span>
            <button (click)="closeDialog()">
                <mat-icon>close</mat-icon>
            </button>
        </div>
        <div class="dialog-content">
            <div>
                <span>Please download the Property Leaflet to access the agent or broker's contact details.</span>
            </div>
            <button mat-button (click)="closeDialog()" class="got-it-button">
                Got It
            </button>
        </div>
    </div>
</div>